import moment from "moment";
import { formatHtmlToCSV } from "shared/utils";

const convertDateToLocal = (date) => {
  return date && moment(date).isValid()
    ? `${moment.utc(date).format("DD MMM YYYY")}`
    : "";
};

export function convertToCSV(formattedData) {
  const { data, headers } = formattedData;
  const array = typeof data != "object" ? JSON.parse(data) : data;
  let str = "";

  for (let i = 0; i < array.length; i++) {
    let line = "";

    for (const currentValue in array[i]) {
      if (line !== "") line += ",";

      const value = array[i][currentValue];

      const dateProcessedData =
        value &&
        (moment(value, "YYYY-MM-DDTHH:mm:ss", true).isValid() ||
          moment(value, "YYYY-MM-DDTHH:mm:ss.SS", true).isValid() ||
          moment(value, "YYYY-MM-DDTHH:mm:ss.SSS", true).isValid())
          ? moment.utc(value).format("DD MMM YYYY")
          : value;

      let valueWithoueArrays;
      if (["transactions"].includes(currentValue)) {
        valueWithoueArrays =
          Array.isArray(dateProcessedData) && dateProcessedData.length > 0
            ? dateProcessedData[0].hasOwnProperty("transactionName")
              ? dateProcessedData
                  .map(({ transactionName }) => transactionName)
                  .join(" | ")
              : dateProcessedData.map(({ nameLong }) => nameLong).join(" | ")
            : String(dateProcessedData || " ");
      } else {
        valueWithoueArrays =
          Array.isArray(dateProcessedData) && dateProcessedData.length > 0
            ? dateProcessedData.map(({ leaseName }) => leaseName).join(" | ")
            : String(dateProcessedData || " ");
      }

      const valueWithoueDoubleQuotes = valueWithoueArrays
        ? String(valueWithoueArrays).replace(/\"/g, "'")
        : String(valueWithoueArrays || " ");

      const cellValue = valueWithoueDoubleQuotes
        .replace(/\n/g, "")
        .replace(/\r/g, "");
      const cellValueWithComma = cellValue.includes(",")
        ? cellValue.replace(/,/g, " ")
        : cellValue;
      const cellValueWithoutDash = cellValueWithComma.includes("–")
        ? cellValueWithComma.replace(/\–/g, "-")
        : cellValueWithComma;

      line += cellValueWithoutDash;
    }

    str += line + "\r\n";
  }
  const firstRow = headers.join(",") + "\r\n";

  return firstRow + str;
}

export const formatData = (data, columnDetails, columnVisibilityModel, filename) => {
  const headers = [];
  const dataKey = [];

  columnDetails = columnDetails.filter((column) => {
    return column.field !== "__check__";
  });

  columnDetails.forEach((column) => {
    const { field, headerName } = column;

    if (
      columnVisibilityModel[field] === undefined ||
      columnVisibilityModel[field] !== false
    ) {
      headers.push(headerName);
      dataKey.push(field);
    }
  });

  const formattedData = data.map((item) => {
    const newItem = {};
    for (const keyName of dataKey) {
      if (
        keyName === "lastCommentCreatedDate" &&
        (filename === "LeaseEvents_snoozed" ||
          filename === "LeaseEvents_ignored")
      ) {
        newItem[keyName] = `${convertDateToLocal(item[keyName])}: ${item["lastComment"]}`;
      } else {
        newItem[keyName] = item[keyName];
      }
    }
    return newItem;
  });

  return { data: formattedData, headers };
};

export const transformLeaseData = (data) => {
  const transformedData = data.map((item) => {
    const {
      rentableBuildingArea,
      uomNameShort,
      noticeDate,
      actionDate,
      expireDate,
      lastComment
    } = item;
    const rentableAreaWithUom = `${rentableBuildingArea || 0}${
      uomNameShort ? ` ${uomNameShort}` : ""
    }`;

    const localNoticeDate = convertDateToLocal(noticeDate);
    const localActionDate = convertDateToLocal(actionDate);
    const localExpireDate = convertDateToLocal(expireDate);
    const localLastComment = formatHtmlToCSV(lastComment);

    return {
      ...item,
      rentableBuildingArea: rentableAreaWithUom,
      noticeDate: localNoticeDate,
      actionDate: localActionDate,
      expireDate: localExpireDate,
      lastComment : localLastComment,
    };
  });
  return transformedData;
};

export const transformTransactionData = (data) => {
  const transformedData = data.map((item) => {
    const { lastComment, lastCommentCreatedDate } = item;
    const lastCommentWithDate =
      lastComment && moment(lastCommentCreatedDate).isValid()
        ? `${moment(lastCommentCreatedDate).utc().format(
            "DD MMM YYYY"
          )}: ${lastComment}`
        : "";
    return { ...item, lastComment: lastCommentWithDate };
  });

  return transformedData;
};
